.dc{aspect-ratio:1/1;}